import tinycolor from "tinycolor2";
import { db } from "../../../firebaseConfig";
import { doc, getDoc, updateDoc, collection, addDoc } from "firebase/firestore";

// import { AuthContext } from '../auth/GoogleSheetsAuth';

let pivot = null;
let viewId;

export const customizeToolbar = (fm, flexmonster, toolbar, handleCSVUpload, viewID, compID, user, handleLibraryModalToggle, handleGooglePickerClicked, handleTitleModalToggle, onSaveWithTitle, handleJSONUpload) => {
  pivot = fm;
  let fmColors = {};
  let userID = user;
  viewId = viewID;
  // console.log("viewID : "+viewID);
  // console.log("userID : "+userID);

  pivot.on("reportcomplete", () => {
    fetchInitialColors("spectrum");
    pivot.customizeChartElement(customizeFunction);
    pivot.off("reportcomplete");
  });

  const colors = {
    ocean: [
      tinycolor("#0574bd"),
      tinycolor("#5fe091"),
      tinycolor("#00cda8"),
      tinycolor("#00b7b8"),
      tinycolor("#009fbd"),
      tinycolor("#aaf07a"),
      tinycolor("#166ca1"),
    ],
    mountain: [
      tinycolor("#0574bd"),
      tinycolor("#F3995D"),
      tinycolor("#FF5C58"),
      tinycolor("#88C3BF"),
      tinycolor("#6EB16A"),
      tinycolor("#F1D365"),
      tinycolor("#166ca1"),
    ],
    sunrise: [
      tinycolor("#ffa600"),
      tinycolor("#2C4992"),
      tinycolor("#955196"),
      tinycolor("#dd5182"),
      tinycolor("#ff6e54"),
      tinycolor("#0f709d"),
      tinycolor("#4d5e6f"),
    ],
    spectrum: [
      tinycolor("#D33E3A"),
      tinycolor("#FF6E54"),
      tinycolor("#FFA600"),
      tinycolor("#D2CEC1"),
      tinycolor("#00CDA8"),
      tinycolor("#009FBD"),
      tinycolor("#166ca1"),
    ],
  };

  let selectedColors = null;

  async function fetchColor(viewId) {
    const docRef = doc(db, "views", viewId);
    try {
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        const colorName = data.color; // Get the color name from Firestore

        if (Object.prototype.hasOwnProperty.call(colors, colorName)) {
          selectedColors = colors[colorName]; // Update selectedColors
          // console.log("View Color:", selectedColors);
          fetchInitialColors(colorName); // Update the colors
        } else {
          // console.warn(`Color name "${colorName}" not found in color palette. Using default spectrum.`);
          selectedColors = colors["spectrum"]; // Fallback to default color
          fetchInitialColors("spectrum");
        }
      } else {
        console.log("No document found for this viewId");
        selectedColors = colors.selectedColors;
        fetchInitialColors("spectrum");
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
      selectedColors = colors.selectedColors;
      fetchInitialColors("spectrum");
    }
  }

  fetchColor(viewId);

  function fetchInitialColors(newSelection) {
    // const memberLabels = pivot.getReport()?.slice?.columns[0]?.uniqueName
    //   ? pivot.getMembers(pivot.getReport()?.slice?.columns[0]?.uniqueName).map((m) => m.caption)
    //   : [];
    // for (let i in memberLabels) {
    //   fmColors[memberLabels[i]] = selectedColors[i];
    // }
    if (!selectedColors) {
      selectedColors = colors[3];
    }
    if (selectedColors) {
      updateCSSVariables(selectedColors);
      document.documentElement.setAttribute("data-theme", newSelection);
      // console.log('data-theme attribute :', document.documentElement.getAttribute('data-theme'));

      // saveColorData()
    }
  }
  const saveColors = async (newSelection) => {
    console.log(newSelection + " Saving color data");
    const docRef = doc(db, "views", viewId);
    try {
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        await updateDoc(docRef, { color: newSelection });
        // console.log("Color data saved successfully");
        window.location.reload();
      } else {
        console.log("Document does not exist! Did not save color.");
      }
    } catch (error) {
      console.error("Error updating color in Firestore:", error);
    }
  };

  async function fetchLibrary() {
    handleLibraryModalToggle(true); // Open the modal when "Open" is clicked
  }

  const saveToLibrary = async (title = "New Library Item") => {
    const libraryCollectionRef = collection(db, "library");
    const newContent = {
      content: JSON.stringify(pivot.getReport()),
      cards: 3,
      type: "data-visualization",
    };

    try {
      const newLibraryDoc = await addDoc(libraryCollectionRef, {
        createdBy: userID,
        contents: newContent,
        title: title,
        createdAt: new Date(),
      });
      console.log("Library data saved successfully with ID:", newLibraryDoc.id);
      // onSaveToLibrary(true); // Call the callback to pass data to the parent
    } catch (error) {
      console.error("Error saving to library:", error);
      // onSaveToLibrary(false); // Call the callback to pass data to the parent
    }
  };

  const handleSaveClick = () => {
    if (handleTitleModalToggle && onSaveWithTitle) {
      handleTitleModalToggle(true);
    } else {
      // Fallback to direct save if modal handlers not available
      saveToLibrary();
    }
  };

  // Expose saveToLibrary function to parent component
  if (onSaveWithTitle) {
    onSaveWithTitle(saveToLibrary);
  }

  // const connectOLAPWithCredentials = () => {
  //   // Set withCredentials for the OLAP connection
  //   flexmonster.ajax.withCredentials = true;

  //   // Define a function to reset the withCredentials flag
  //   const resetAjaxCredentials = () => {
  //     flexmonster.ajax.withCredentials = false;
  //     // Remove the event listeners to avoid memory leaks
  //     pivot.off("reportcomplete", resetAjaxCredentials);
  //     pivot.off("reportfilecancelled", resetAjaxCredentials);
  //     pivot.off("connectionerror", resetAjaxCredentials);
  //     pivot.off("closeolap", resetAjaxCredentials); // Also reset if the dialog is closed
  //   };

  //   // Add event listeners to reset the flag when the connection is done
  //   pivot.on("reportcomplete", resetAjaxCredentials);
  //   pivot.on("reportfilecancelled", resetAjaxCredentials);
  //   pivot.on("connectionerror", resetAjaxCredentials);
  //   pivot.on("closeolap", resetAjaxCredentials); // For when user closes the OLAP popup

  //   // Open the OLAP connection dialog
  //   pivot.connectTo("olap");
  // };

  /////////////////////////////
  // SAVE COLOR TO COMPONENT //
  /////////////////////////////

  //
  // const saveColorData = useCallback(
  //   async (report) => {
  //     console.log("viewId : "+viewId);
  //     // console.log(newSelection+"Saving color data", report);
  //     const docRef = doc(db, "views", viewId);
  //     try {
  //       const docSnap = await getDoc(docRef);
  //       if (docSnap.exists()) {
  //         let newColor = docSnap.data().contents.color || [];
  //         const index = contentArray.findIndex((comp) => comp.id === componentId);

  //         await updateDoc(docRef, { contents: contentArray });
  //         console.log("Color data saved successfully");
  //       } else {
  //         console.log("Document does not exist!");
  //       }
  //     } catch (error) {
  //       console.error("Error updating Flexmonster data in Firestore:", error);
  //     }
  //   },
  //   [componentId, viewId]
  // );

  function updateCSSVariables(selectedColors) {
    const root = document.documentElement;
    root.style.setProperty("--color-1", selectedColors[0].toString());
    root.style.setProperty("--color-2", selectedColors[1].toString());
    root.style.setProperty("--color-3", selectedColors[2].toString());
    root.style.setProperty("--color-4", selectedColors[3].toString());
    root.style.setProperty("--color-5", selectedColors[4].toString());
    root.style.setProperty("--color-6", selectedColors[5].toString());
    root.style.setProperty("--color-7", selectedColors[6].toString());
    root.style.setProperty("--color-8", selectedColors[7] ? selectedColors[7].toString() : "none");
    root.style.setProperty("--color-9", "none");

    // console.log("color 1 - "+root.style.getPropertyValue('--color-1'));
    // console.log("color 6 - "+root.style.getPropertyValue('--color-5'));

    // console.log("pivot ; "+pivot);
    // pivot.current.flexmonster.refresh();
  }

  function customizeFunction(element, data) {
    // customizeChartElementFunction(element, data);

    if (data.type == "legend") {
      element.querySelector(".fm-icon-display").style.backgroundColor = fmColors[data.label];
    }

    if (data.type == "path") {
      element.style.border = fmColors[data.label];
    }

    if (data.chartType == "line") {
      if (element.querySelector("path")) {
        element.querySelector("path").style.border = fmColors[data.label];
      } else if (element.querySelector("circle")) {
        element.querySelector("circle").style.borderColor = fmColors[data.label];
      }
    }

    if (data.type == "series") {
      element.style.fill = fmColors[data.label];
    }

    if (data.type == "circle") {
      element.style.border = fmColors[data.label];
    }

    if (data.chartType == "pie") {
      if (element.querySelector("path")) {
        element.querySelector("path").style.fill = fmColors[data.label];
      }
    } else {
      element.style.fill = fmColors[data.label];
    }

    if (data.chartType == "scatter") {
      element.style.fill = fmColors[data.label];
      element.style.border = fmColors[data.label];
      // element.querySelector('circle').style.fill = fmColors[data.label];

      // element.style.backgroundColor = fmColors[data.label];
    }
    if (data.chartType == "bar") {
      element.style.fill = fmColors[data.label];
    }
    if (data.chartType == "column") {
      element.style.fill = fmColors[data.label];
    }
  }

  // const applyColor = (newColor) => {
  //   selectedColors = colors[{newColor}]
  // }

  // UPLOAD TO GOOGLE BUCKET
  // async function uploadToGoogleStorage(file) {
  //   // **IMPORTANT: Replace placeholders with your actual values**
  //   const bucketName = "gs://data-sculpture-ai.appspot.com/";

  //   // Get current user's UUID (assuming you have a way to get this)
  //   const userUUID = getCurrentUserUUID(); // Replace with your logic

  //   // Construct object name using user's UUID
  //   const objectName = `library-files/${userUUID}/${file.name}`;

  //   // You'll need to set up Google Cloud Storage client library for this
  //   // and authenticate appropriately.
  //   // Example using @google-cloud/storage:
  //   const { Storage } = require("@google-cloud/storage");
  //   const storage = new Storage();
  //   const bucket = storage.bucket(bucketName);

  //   try {
  //     const [response] = await bucket.upload(file, {
  //       destination: objectName,
  //       // Add any other desired upload options here
  //     });

  //     // Make the file publicly accessible (optional, but often needed)
  //     await response.makePublic();

  //     // Get the public URL of the uploaded file
  //     const publicUrl = `https://storage.googleapis.com/${bucketName}/${objectName}`;
  //     return publicUrl;
  //   } catch (error) {
  //     console.error("Error uploading to Google Cloud Storage:", error);
  //     throw error; // Re-throw to handle in the calling function
  //   }
  // }

  // // Example function to get the current user's UUID
  // function getCurrentUserUUID() {
  //   // Replace with your actual logic to fetch the user's UUID
  //   // This could involve:
  //   // - Getting it from local storage or cookies
  //   // - Making an API request to your authentication system
  //   // ...
  //   const userUUID = localStorage.getItem("userUUID");
  //   if (!userUUID) {
  //     console.error("User UUID not found!");
  //     // Handle the case where user UUID is not available
  //   }
  //   return userUUID;
  //}

  let tabs = toolbar.getTabs();
  toolbar.getTabs = () => {
    tabs = [];
    // Source tab
    tabs.push({
      id: "fm-tab-customDataSources",
      title: "Connector",
      mobile: true,

      icon: (toolbar.icons.connect =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path fill="var(--Grey7)" d="M11 13a1 1 0 1 0 1 1a1 1 0 0 0-1-1m-4 0a1 1 0 1 0 1 1a1 1 0 0 0-1-1m15-9a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v4a3 3 0 0 0 .78 2A3 3 0 0 0 2 12v4a3 3 0 0 0 3 3h6v2H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2h-8v-2h6a3 3 0 0 0 3-3v-4a3 3 0 0 0-.78-2A3 3 0 0 0 22 8Zm-2 12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Zm0-8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Zm-9-3a1 1 0 1 0 1 1a1 1 0 0 0-1-1M7 5a1 1 0 1 0 1 1a1 1 0 0 0-1-1"/></svg>'),
      menu: [
        // {
        //   title: "Upload CSV to storage bucket",
        //   handler: uploadCSVHandler,
        //   mobile: false,
        //   icon: toolbar.icons.connect_json,
        // },
        {
          title: "Open",
          id: "library.open",
          handler: fetchLibrary,
          icon: toolbar.icons.open_remote,
        },

        {
          title: "Save",
          id: "library.save",
          handler: handleSaveClick,
          mobile: false,
          icon: toolbar.icons.save,
        },
        {
          title: "——————",
        },

        {
          title: "Google Sheets",
          handler: handleGooglePickerClicked,
          flat: false,
          icon: (toolbar.icons.open =
            '<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 512 512" style={{ marginLeft: "12px" }} > <rect width="512" height="512" fill="none" rx="15%" /> <path fill="var(--Grey7)" d="M386 400c45-42 65-112 53-179H260v74h102c-4 24-18 44-38 57z" /> <path fill="dark grey" d="M90 341a192 192 0 0 0 296 59l-62-48c-53 35-141 22-171-60z" /> <path fill="medium gray" d="M153 292c-8-25-8-48 0-73l-63-49c-23 46-30 111 0 171z" /> <path fill="dark charcoal" d="M153 219c22-69 116-109 179-50l55-54c-78-75-230-72-297 55z" /> </svg>'),
        },
        {
          title: "Elasticsearch",
          handler: toolbar.connectElastic,
          flat: false,
          icon: toolbar.icons.connect_elastic,
        },
        {
          id: "uploadCSV",
          icon: toolbar.icons.connect_csv,
          title: "Local CSV",
          handler: () => {
            const input = document.createElement("input");
            input.type = "file";
            input.accept = ".csv";
            input.onchange = (event) => {
              const file = event.target.files[0];
              handleCSVUpload(file);
            };
            input.click();
          },
        },
        {
          title: "Local JSON",
          handler: () => {
            const input = document.createElement("input");
            input.type = "file";
            input.accept = ".json";
            input.onchange = (event) => {
              const file = event.target.files[0];
              if (handleJSONUpload) {
                handleJSONUpload(file);
              } else {
                toolbar.connectLocalJSONHandler();
              }
            };
            input.click();
          },
          mobile: false,
          icon: toolbar.icons.connect_json,
        },
        // {
        //   title: "Remote CSV",
        //   handler: toolbar.connectRemoteCSV,
        //   mobile: false,
        //   icon: toolbar.icons.connect_csv_remote,
        // },
        // {
        //   title: "Remote JSON",
        //   handler: toolbar.connectRemoteJSON,
        //   icon: toolbar.icons.connect_json_remote,
        // },
        {
          title: "OLAP",
          handler: toolbar.connectOLAP,
          flat: false,
          icon: toolbar.icons.connect_olap,
        },
      ],
    });
    // Open tab
    // tabs.push({
    //   title: "Library",
    //   id: "",
    //   mobile: true,
    //   icon: (toolbar.icons.open =
    //     '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path fill="var(--Grey7)" d="M22.78 10.37A1 1 0 0 0 22 10h-2V9a3 3 0 0 0-3-3h-6.28l-.32-1a3 3 0 0 0-2.84-2H4a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14.4a3 3 0 0 0 2.92-2.35L23 11.22a1 1 0 0 0-.22-.85M5.37 18.22a1 1 0 0 1-1 .78H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h3.56a1 1 0 0 1 1 .68l.54 1.64A1 1 0 0 0 10 8h7a1 1 0 0 1 1 1v1H8a1 1 0 0 0-1 .78Zm14 0a1 1 0 0 1-1 .78H7.21a1.42 1.42 0 0 0 .11-.35L8.8 12h12Z"/></svg>'),
    //   menu: [
    //     {
    //       title: "Save",
    //       id: "library.save",
    //       handler: saveToLibrary,
    //       mobile: false,
    //       icon: toolbar.icons.save,
    //     },
    //     {
    //       title: "Open",
    //       id: "library.open",
    //       handler: fetchLibrary,
    //       icon: toolbar.icons.open_remote,
    //     },
    //   ],
    // });

    // Save tab
    // tabs.push({
    //   title: toolbar.save,
    //   id: "fm-tab-save",
    //   handler: saveToLibrary,
    //   mobile: true,
    //   icon: (toolbar.icons.save =
    //     '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path fill="var(--Grey7)" d="m20.71 9.29l-6-6a1 1 0 0 0-.32-.21A1.09 1.09 0 0 0 14 3H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-8a1 1 0 0 0-.29-.71M9 5h4v2H9Zm6 14H9v-3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1Zm4-1a1 1 0 0 1-1 1h-1v-3a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3v3H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V6.41l4 4Z"/></svg>'),
    // });

    // Format tab
    tabs.push({
      title: toolbar.format,
      id: "fm-tab-format",
      icon: (toolbar.icons.format =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px"  viewBox="0 0 24 24" id="ruler-combined"><path fill="var(--Grey7)" d="M21,2H3A1,1,0,0,0,2,3V21a1,1,0,0,0,1,1H9a1,1,0,0,0,1-1V10H21a1,1,0,0,0,1-1V3A1,1,0,0,0,21,2ZM20,8H18V7a1,1,0,0,0-2,0V8H14V7a1,1,0,0,0-2,0V8H10V7A1,1,0,0,0,8,7V8H7a1,1,0,0,0,0,2H8v2H7a1,1,0,0,0,0,2H8v2H7a1,1,0,0,0,0,2H8v2H4V4H20Z"></path></svg>'),
      mobile: false,

      menu: [
        {
          // Fields tab
          title: toolbar.fields,
          id: "fm-tab-fields",
          handler: toolbar.fieldsHandler,
          icon: toolbar.icons.fields,
          mobile: false,

          // icon: (toolbar.icons.fields =
          //   '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24px" height="24px" id="table"><path fill="var(--Grey7)" d="M21,2H3A1,1,0,0,0,2,3V21a1,1,0,0,0,1,1H21a1,1,0,0,0,1-1V3A1,1,0,0,0,21,2ZM8,20H4V16H8Zm0-6H4V10H8ZM8,8H4V4H8Zm6,12H10V16h4Zm0-6H10V10h4Zm0-6H10V4h4Zm6,12H16V16h4Zm0-6H16V10h4Zm0-6H16V4h4Z"></path></svg>'),
        },
        {
          // Format Cells tab
          title: toolbar.format_cells,
          id: "fm-tab-format-cells",
          handler: toolbar.formatCellsHandler,
          icon: toolbar.icons.format_number,
          mobile: false,
        },
        {
          // Conditional Format tab
          //  title: toolbar.osUtils.isMobile
          //     ? toolbar.conditional_formatting_mobile
          title: toolbar.conditional_formatting,
          id: "fm-tab-format-conditional",
          handler: toolbar.conditionalFormattingHandler,
          icon: toolbar.icons.format_conditional,
          mobile: false,
        },
        {
          // Totals tab
          title: "Options",
          handler: toolbar.optionsHandler,
          icon: toolbar.icons.options,
          mobile: false,

          // icon: (toolbar.icons.options =
          //   '<svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 24 24" width="24px" height="24px" id="setting"><path fill="#D9D9D9" d="M19.9 12.66a1 1 0 0 1 0-1.32l1.28-1.44a1 1 0 0 0 .12-1.17l-2-3.46a1 1 0 0 0-1.07-.48l-1.88.38a1 1 0 0 1-1.15-.66l-.61-1.83a1 1 0 0 0-.95-.68h-4a1 1 0 0 0-1 .68l-.56 1.83a1 1 0 0 1-1.15.66L5 4.79a1 1 0 0 0-1 .48L2 8.73a1 1 0 0 0 .1 1.17l1.27 1.44a1 1 0 0 1 0 1.32L2.1 14.1a1 1 0 0 0-.1 1.17l2 3.46a1 1 0 0 0 1.07.48l1.88-.38a1 1 0 0 1 1.15.66l.61 1.83a1 1 0 0 0 1 .68h4a1 1 0 0 0 .95-.68l.61-1.83a1 1 0 0 1 1.15-.66l1.88.38a1 1 0 0 0 1.07-.48l2-3.46a1 1 0 0 0-.12-1.17ZM18.41 14l.8.9-1.28 2.22-1.18-.24a3 3 0 0 0-3.45 2L12.92 20h-2.56L10 18.86a3 3 0 0 0-3.45-2l-1.18.24-1.3-2.21.8-.9a3 3 0 0 0 0-4l-.8-.9 1.28-2.2 1.18.24a3 3 0 0 0 3.45-2L10.36 4h2.56l.38 1.14a3 3 0 0 0 3.45 2l1.18-.24 1.28 2.22-.8.9a3 3 0 0 0 0 3.98Zm-6.77-6a4 4 0 1 0 4 4 4 4 0 0 0-4-4Zm0 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2Z"></path></svg>'),
        },
      ],
    });
    // Divider
    tabs.push({
      divider: true,
      mobile: true,
    });

    // Table tab
    // tabs.push({
    //   title: "Table",
    //   handler: toolbar.gridHandler,
    //   mobile: false,

    //   icon: (toolbar.icons.grid =
    //     '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" id="grid"><path fill="#D9D9D9" d="M21,2H3A1,1,0,0,0,2,3V21a1,1,0,0,0,1,1H21a1,1,0,0,0,1-1V3A1,1,0,0,0,21,2ZM11,20H4V16h7Zm0-6H4V10h7Zm9,6H13V16h7Zm0-6H13V10h7Zm0-6H4V4H20Z"></path></svg>'),
    // });
    // Charts tab
    tabs.push({
      title: "Visual",
      // id: "fm-tab-charts",
      mobile: false,

      onShowHandler: toolbar.checkChartMultipleMeasures,
      icon: (toolbar.icons.chart =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path fill="var(--Grey7)" d="M12 6a1 1 0 0 0-1 1v10a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1m-5 6a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1m10-2a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0v-6a1 1 0 0 0-1-1m2-8H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m1 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z"/></svg>'),
      menu: [
        {
          title: "Table",
          handler: () => {
            pivot.setOptions({ grid: { type: "flat" } });
            pivot.showGrid();
          },
          mobile: false,
          icon: toolbar.icons.grid,
        },
        {
          title: toolbar.charts_column,
          id: "fm-tab-charts-column",
          handler: toolbar.chartsHandler,
          args: "column",
          mobile: false,

          icon: toolbar.icons.charts,
        },
        {
          title: toolbar.charts_bar_horizontal,
          id: "fm-tab-charts-bar-horizontal",
          handler: toolbar.chartsHandler,
          args: "bar_h",
          mobile: false,

          icon: toolbar.icons.charts_bar,
        },
        {
          title: toolbar.charts_line,
          id: "fm-tab-charts-line",
          handler: toolbar.chartsHandler,
          args: "line",
          mobile: false,

          icon: toolbar.icons.charts_line,
        },
        {
          title: toolbar.charts_scatter,
          id: "fm-tab-charts-scatter",
          handler: toolbar.chartsHandler,
          args: "scatter",
          mobile: false,
          icon: toolbar.icons.charts_scatter,
        },
        {
          title: toolbar.charts_pie,
          id: "fm-tab-charts-pie",
          handler: toolbar.chartsHandler,
          args: "pie",
          mobile: false,
          icon: toolbar.icons.charts_pie,
        },
        {
          title: toolbar.charts_stacked_column,
          id: "fm-tab-charts-stacked-column",
          handler: toolbar.chartsHandler,
          args: "stacked_column",
          flat: false,
          mobile: false,
          icon: toolbar.icons.charts_stacked_column,
        },
        {
          title: toolbar.charts_column_line,
          id: "fm-tab-charts-column-line",
          handler: toolbar.chartsHandler,
          args: "column_line",
          mobile: false,
          icon: toolbar.icons.charts_column_line,
        },
        {
          title: toolbar.charts_multiple,
          id: "fm-tab-charts-multiple",
          handler: toolbar.chartsMultipleHandler,
          flat: false,
          mobile: false,
          type: "checkbox",
        },
      ],
    });

    // Color tab
    tabs.push({
      title: "Color",
      id: "fm-tab-color",
      mobile: false,

      icon: (toolbar.icons.open =
        '<svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 24 24"  width="24px" height="24px" id="palette"><path fill="var(--Grey7)" d="M7.42,15.54a1,1,0,0,0,0,1.41,1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.41A1,1,0,0,0,7.42,15.54Zm0-8.49a1,1,0,0,0,0,1.41,1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.41A1,1,0,0,0,7.42,7.05Zm4.95,10a1,1,0,1,0,1,1A1,1,0,0,0,12.37,17Zm-6-6a1,1,0,1,0,1,1A1,1,0,0,0,6.37,11Zm6-6a1,1,0,1,0,1,1A1,1,0,0,0,12.37,5Zm3.54,2.05a1,1,0,1,0,1.41,0A1,1,0,0,0,15.91,7.05Zm6.3,0a11,11,0,1,0-7.85,15.74,3.87,3.87,0,0,0,2.5-1.65A4.2,4.2,0,0,0,17.47,18a5.65,5.65,0,0,1-.1-1,5,5,0,0,1,3-4.56,3.84,3.84,0,0,0,2.06-2.25A4,4,0,0,0,22.21,7.08Zm-1.7,2.44a1.9,1.9,0,0,1-1,1.09A7,7,0,0,0,15.37,17a7.3,7.3,0,0,0,.14,1.4,2.16,2.16,0,0,1-.31 1.65,1.79,1.79,0,0,1-1.21.8,8.72,8.72,0,0,1-1.62.15,9,9,0,0,1-9-9.28A9.05,9.05,0,0,1,11.85,3h.51a9,9,0,0,1,8.06,5A2,2,0,0,1,20.51,9.52ZM12.37,11a1,1,0,1,0,1,1A1,1,0,0,0,12.37,11Z"></path></svg>'),
      menu: [
        {
          title: " Ocean - Volume",
          //id: "ocean",
          handler: () => {
            selectedColors = colors.ocean;
            saveColors("ocean");
            fetchInitialColors("ocean");
            // pivot.customizeChartElement(customizeFunction);
          },
          //handler: applyOcean,
          icon: (toolbar.icons.open =
            '<svg width="86" height="40" viewBox="0 0 86 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="24.6573" width="12.028" height="40" fill="#00CDA8"/><rect x="36.986" width="12.028" height="40" fill="#00B7B8"/><rect x="49.3147" width="12.028" height="40" fill="#009FBD"/><rect width="12.028" height="40" fill="#AAF07A"/><rect x="73.972" width="12.028" height="40" fill="#166CA1"/><rect x="12.3287" width="12.028" height="40" fill="#5FE091"/><rect x="61.6434" width="12.028" height="40" fill="#0086B5"/></svg>'),
        },
        {
          title: " Mountain - Category",
          //id: "fm-tab-open-remote-report",
          handler: () => {
            selectedColors = colors.mountain;
            saveColors("mountain");
            fetchInitialColors("mountain");

            // pivot.customizeChartElement(customizeFunction);
          },
          // handler: applyMountain,
          icon: (toolbar.icons.open =
            '<svg width="86" height="40" viewBox="0 0 86 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="24.6573" width="12.028" height="40" fill="#FF5C58"/><rect x="49.3147" width="12.028" height="40" fill="#6EB16A"/><rect x="36.986" width="12.028" height="40" fill="#88C3BF"/><rect x="12.3287" width="12.028" height="40" fill="#F4ACB5"/><rect x="61.6434" width="12.028" height="40" fill="#D2CEC1"/><rect x="73.972" width="12.028" height="40" fill="#9D755D"/><rect width="12.028" height="40" fill="#0086B5"/></svg>'),
        },
        {
          title: " Sunrise - Category",
          // id: "fm-tab-open-local-report",
          handler: () => {
            selectedColors = colors.sunrise;
            saveColors("sunrise");
            fetchInitialColors("sunrise");
            // pivot.customizeChartElement(customizeFunction);
          },
          // handler: applySunrise,
          icon: (toolbar.icons.open =
            '<svg width="86" height="40" viewBox="0 0 86 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="24.6573" width="12.028" height="40" fill="#955196"/><rect x="36.986" width="12.028" height="40" fill="#DD5182"/><rect x="49.3147" width="12.028" height="40" fill="#FF6E54"/><rect x="61.6434" width="12.028" height="40" fill="#FFA600"/><rect x="73.972" width="12.028" height="40" fill="#D2CEC1"/><rect x="12.3287" width="12.028" height="40" fill="#2D4B98"/><rect width="12.028" height="40" fill="#034767"/></svg>'),
        },
        {
          title: "Spectrum - Divergent",
          // id: "fm-tab-open-remote-report",
          handler: () => {
            selectedColors = colors.spectrum;
            saveColors("spectrum");
            fetchInitialColors("spectrum");
            // pivot.customizeChartElement(customizeFunction);
          },
          // handler: applySpectrum,
          icon: (toolbar.icons.open =
            '<svg width="86" height="40" viewBox="0 0 86 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="12.028" height="40" fill="#D33E3A"/><rect x="36.986" width="12.028" height="40" fill="#D2CEC1"/><rect x="12.3287" width="12.028" height="40" fill="#FF6E54"/><rect x="24.6573" width="12.028" height="40" fill="#FFA600"/><rect x="49.3147" width="12.028" height="40" fill="#00CDA8"/><rect x="61.6434" width="12.028" height="40" fill="#009FBD"/><rect x="73.972" width="12.028" height="40" fill="#166CA1"/></svg>'),
        },
      ],
    });

    // Export tab
    tabs.push({
      title: toolbar.export,
      id: "fm-tab-export",
      mobile: true,
      rightGroup: true,
      icon: (toolbar.icons.export =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path fill="var(--Grey7)" d="M20.92 15.62a1.15 1.15 0 0 0-.21-.33l-3-3a1 1 0 0 0-1.42 1.42l1.3 1.29H12a1 1 0 0 0 0 2h5.59l-1.3 1.29a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0l3-3a.93.93 0 0 0 .21-.33a1 1 0 0 0 0-.76M14 20H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h4a1 1 0 0 0 .92-.62a1 1 0 0 0-.21-1.09l-6-6a1.07 1.07 0 0 0-.28-.19h-.09l-.28-.1H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h8a1 1 0 0 0 0-2M13 5.41L15.59 8H14a1 1 0 0 1-1-1Z"/></svg>'),
      menu: [
        {
          title: toolbar.export_print,
          id: "fm-tab-export-print",
          handler: toolbar.printHandler,
          icon: toolbar.icons.export_print,
        },
        {
          title: toolbar.export_html,
          id: "fm-tab-export-html",
          handler: toolbar.exportHandler,
          args: "html",
          icon: toolbar.icons.export_html,
        },
        {
          title: toolbar.export_csv,
          id: "fm-tab-export-csv",
          handler: toolbar.exportHandler,
          args: "csv",
          icon: toolbar.icons.export_csv,
        },
        {
          title: toolbar.export_excel,
          id: "fm-tab-export-excel",
          handler: toolbar.exportHandler,
          args: "excel",
          icon: toolbar.icons.export_excel,
        },
        {
          title: toolbar.export_image,
          id: "fm-tab-export-image",
          handler: toolbar.exportHandler,
          args: "image",
          icon: toolbar.icons.export_image,
        },
        {
          title: toolbar.export_pdf,
          id: "fm-tab-export-pdf",
          handler: toolbar.exportHandler,
          args: "pdf",
          icon: toolbar.icons.export_pdf,
        },
      ],
    });

    // Fullscreen tab
    if (document["addEventListener"] != undefined) {
      // For IE8
      tabs.push({
        divider: true,
        rightGroup: true,
      });
      tabs.push({
        title: toolbar.fullscreen,
        id: "fm-tab-fullscreen",
        handler: toolbar.fullscreenHandler,
        mobile: false,
        icon: (toolbar.icons.fullscreen =
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24px" height="24px" id="expand-arrows-alt"><path fill="var(--Grey7)" d="M9.29,13.29,4,18.59V17a1,1,0,0,0-2,0v4a1,1,0,0,0,.08.38,1,1,0,0,0,.54.54A1,1,0,0,0,3,22H7a1,1,0,0,0,0-2H5.41l5.3-5.29a1,1,0,0,0-1.42-1.42ZM5.41,4H7A1,1,0,0,0,7,2H3a1,1,0,0,0-.38.08,1,1,0,0,0-.54.54A1,1,0,0,0,2,3V7A1,1,0,0,0,4,7V5.41l5.29,5.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42ZM21,16a1,1,0,0,0-1,1v1.59l-5.29-5.3a1,1,0,0,0-1.42,1.42L18.59,20H17a1,1,0,0,0,0,2h4a1,1,0,0,0,.38-.08,1,1,0,0,0,.54-.54A1,1,0,0,0,22,21V17A1,1,0,0,0,21,16Zm.92-13.38a1,1,0,0,0-.54-.54A1,1,0,0,0,21,2H17a1,1,0,0,0,0,2h1.59l-5.3,5.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L20,5.41V7a1,1,0,0,0,2,0V3A1,1,0,0,0,21.92,2.62Z"></path></svg>'),
        rightGroup: true,
      });
    }

    return tabs;
  };
};
